import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useEffect } from "react";
import Checkbox from "./Checkbox";

export default function TabSelector({ isEdit, interview }) {
  const { CommonStore } = useStores();
  let isMobile = false;
  function getFirstWord(item) {
    if (item === "Technical interview") {
      return "Tech";
    }
    return item.split(" ")[0];
  }
  useEffect(() => {
    if (window.innerWidth < 1000) {
      isMobile = true;
    }
  }, []);

  return useObserver(() => (
    <>
      <div className="sm:my-8 tc1:mt-8 tc1:mb-2 w-[100%] ">
        {/* <h1 className="text-primary font-bold text-xl ">Create new Chatbot </h1> */}
        <div
          className={`flex md:w-[100%] lg:w-[100%] w-[90%] md:mx-0 lg:mx-0 mx-auto checkbox-container  my-4 ${
            CommonStore.progress > 0 ? "first" : ""
          } ${CommonStore.progress > 1 ? "sec" : ""} ${
            CommonStore.progress > 2 ? "third" : ""
          }  ${CommonStore.progress > 3 ? "fourth" : ""} 
          ${CommonStore.progress > 4 ? "fifth" : ""}
          ${CommonStore.progress > 5 ? "sixth" : ""}
          ${CommonStore.progress > 6 ? "seventh" : ""}
          ${CommonStore.progress > 7 ? "eighth" : ""}
          ${CommonStore.progress > 8 ? "ninth" : ""}
          `}
        >
          {(interview ? CommonStore.interviewLabels : CommonStore.label).map(
            (item, index) => (
              <div className="relative md:w-1/5 lg:w-1/5 w-[15%] h-16  ml-1  ">
                <Checkbox
                  skipped={item.skipped}
                  label={
                    window.innerWidth < 1000
                      ? getFirstWord(item.item)
                      : item.item
                  }
                  active={item.isActive}
                  completed={
                    item.item === "Basic Job Details"
                      ? true
                      : CommonStore.progress > index
                  }
                  isEdit={isEdit}
                  ind={index}
                />
              </div>
            )
          )}
          {/* <div className="relative w-1/4 ">
          <Checkbox label="Basic Information" completed={true} />
        </div>
        <div className="relative w-1/4">
          <Checkbox
            label="chatbot settings"
            completed={CommonStore.progress > 0}
          />
        </div>
        <div className="relative w-1/4">
          <Checkbox label="Lead Info" completed={CommonStore.progress > 1} />
        </div>
        <div className="relative w-1/4">
          <Checkbox
            label="chatbot preview"
            completed={CommonStore.progress > 2}
          />
        </div> */}
        </div>
      </div>
    </>
  ));
}
